/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceQueryTagKeyValue extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceQueryTagKeyValue");
    }

    getFixupPrototypeFunction() { return ResourceQueryTagKeyValue.fixupPrototype; }

    static newInstance(model: Partial<ResourceQueryTagKeyValue>): ResourceQueryTagKeyValue {
        let obj = Object.assign(new ResourceQueryTagKeyValue(), model);
        ResourceQueryTagKeyValue.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceQueryTagKeyValue>): ResourceQueryTagKeyValue {
        if (!model) return null;
        return ResourceQueryTagKeyValue.newInstance(<ResourceQueryTagKeyValue> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceQueryTagKeyValue) {
        if (!obj) return;

        models.ResourceQueryTagKeyValue.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceQueryTagKeyValue): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceQueryTagKeyValue.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tag key for the given resources
     */
    tag_key: string;

    /**
     * Tag values for the given key
     */
    tag_values: Array<string>;

    /**
     * Tag kind if applicable
     */
    tag_kind: string;

}
